import { defineApi } from '@/utils/fetch';

import type { IResolveOffersParams, IResolveOffersV2Data } from './typings';

/**
 * 活动编排 API
 *
 * - resolveOffersV2：POST /commerce/activity/offersresolve/v2（activity_api.thrift）
 */

const rawResolveOffersV2 = defineApi<IResolveOffersParams, IResolveOffersV2Data>({
    url: '/commerce/activity/offersresolve/v2',
    method: 'POST',
});

export const ActivityApi = {
    /**
     * ResolveOffersV2：活动列表 + 扁平商品，通过 activity_id 关联
     * IDL: CommerceActivityApiService.ResolveOffersV2
     */
    resolveOffersV2: (params: IResolveOffersParams) => rawResolveOffersV2(params),
};

export * from './typings';
